module.exports = __webpack_public_path__ + "static/media/facial_recog.125ad9e0.jpg";